<template>
  <div class="block">
    <v-card-subtitle>Select GPU and Output</v-card-subtitle>
    <v-divider class="block__divider" />
    <ChangeGPU
      :GPUS="GPUS"
      :currentConfigName="currentConfigName"
      @updateConfig="(newConfig) => (currentConfig = newConfig)"
      @updateGPUS="(newGPUData) => (GPUS = newGPUData)" />
  </div>

  <div class="block">
    <v-card-subtitle>Reset CanvasPro Device Config</v-card-subtitle>
    <v-divider class="block__divider" />
    <DeviceConfigResetButton
      @updateGPUS="(newGPUData) => (GPUS = newGPUData)"
      @updateConfig="(newConfig) => (currentConfig = newConfig)"
      @updateConfigName="
        (newConfigName) => (currentConfigName = newConfigName)
      " />
  </div>

  <!-- <div class="block">
    <v-card-subtitle>Current Config</v-card-subtitle>
    <v-divider class="block__divider" />
    <DisplayDeviceConfig
      :currentConfig="currentConfig"
      :currentConfigName="currentConfigName"
      :canvasProConfigName="canvasProConfigName" />
  </div> -->
</template>

<script setup>
import {
  getGPUInfo,
  getCurrentConfigName,
  getConfig,
} from '../../../utils/ventuzConfig';

import { ref, watch, onMounted } from 'vue';
import ChangeGPU from '../../Shared/ChangeGPU.vue';
import DeviceConfigResetButton from './SubComponents/DeviceConfigResetButton.vue';
import DisplayDeviceConfig from './SubComponents/DisplayDeviceConfig.vue';

const canvasProConfigName = 'CanvasPro';

// Avoid top-level await so module import cannot fail at load time.
const GPUS = ref([]);
const currentConfigName = ref(canvasProConfigName);
const currentConfig = ref({});

onMounted(async () => {
  try {
    GPUS.value = await getGPUInfo();
  } catch (e) {
    GPUS.value = [];
    console.error('Failed to load GPU info', e);
  }

  try {
    const name = await getCurrentConfigName();
    currentConfigName.value = name || canvasProConfigName;
  } catch (e) {
    console.error('Failed to load current config name', e);
    currentConfigName.value = canvasProConfigName;
  }

  try {
    currentConfig.value = await getConfig(currentConfigName.value);
  } catch (e) {
    console.error('Failed to load current config', e);
    currentConfig.value = {};
  }
});
</script>
<style scoped>
.bad-config {
  background-color: red;
}
.good-config {
  background-color: green;
}

.gpu-output {
  outline: 1px solid rebeccapurple;
  padding: 1rem;
  list-style-type: none;
}

.gpu-output ul {
  padding: 1rem;
  list-style-type: none;
  outline: 1px solid red;
}

.block {
  margin-top: 40px;
  margin-bottom: 20px;
}

.block .block__divider {
  margin-bottom: 20px;
}
</style>
